import React from "react";

export default function DtiSectionHeading({ children }) {
  return <h3 className="dti-subheading">{children}</h3>;
}
